export const masonryFirstElement = {
  license: 'string',
  id: 123,
  url: '/create/editor?customSize=1080x1080&unit=px&category=layout',
  title: 'Create a blank flyer',
  tags: ['', ''],
  mature: true,
  width: 300,
  height: 300,
  created: 'string',
  type: 'image',
  public: true,
  likes_count: 0,
  is_liked: false,
  is_saved: false,
  comments_count: 0,
  streams_count: 0,
  reposts_count: 0,
  forks_count: 0,
  show_edit_history: false,
  history_uploaded: false,
  sources_count: 0,
  has_similars: false,
};

export const mobileColumnCount = 2;
